import React, { Component } from 'react';
import Config from "../../../../config/config";

import '../../../../styles/App.css';

export default class CommercialDevice extends Component {

	constructor(props) {
		super(props);
		this.state = {
			voucherButtonClass: "voucherButton"
		}
		console.log("CommercialDevice::", props);
	}
	
	componentDidMount() {
		window.scrollTo(0, 0);
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Commercial',
			'page_path': '/commercial'
		});
	}

	voucherButtonClick = () => {
		if (this.state.voucherButtonClass.indexOf("clicked") === -1)
			this.setState({voucherButtonClass: this.state.voucherButtonClass + " clicked"});
	}

	render() {
		const commercialUrl = window.location.origin + "/media/commercial/device_commercial.png";
		return(
			<div className="voucher">			
				<div className="voucherTitle">Hey <span className="userName">{this.props.userName}</span>, <br/> Kom je snel ff scheuren? </div>					
				<img src={commercialUrl} style={{width:"100%"}} alt="commercial" />
				<div className={this.state.voucherButtonClass} onClick={this.voucherButtonClick}></div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/Quiz/CommercialDevice/CommercialDevice.js